import axios from 'axios';
import { getKeycloak } from '../config/keycloak';

const rawApiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const normalisedApiUrl = (() => {
  const trimmed = rawApiUrl.replace(/\/$/, '');
  if (trimmed.endsWith('/api/v1')) return trimmed;
  if (trimmed.endsWith('/api')) return `${trimmed}/v1`;
  return `${trimmed}/api/v1`;
})();

const api = axios.create({
  baseURL: normalisedApiUrl,
});

api.interceptors.request.use(
  (config) => {
    const keycloak = getKeycloak();
    if (keycloak?.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const licenseApi = {
  getStatus: () =>
    api.get('/license/status'),

  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/license/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

};
